import { store } from '@/store';
import api from '@api/Api';

export default {

    getProject(id) {
        return api().get(`/projects/${id}`).then((response) => {
            store.commit('setProject', response.data.data);
            return response;
        });
    },

    updateProject(id, params) {
        return api().put(`/projects/${id}`, params);
    },

    favoriteProject(id) {
        return api().put(`/projects/${id}/favorite`);
    },

    unfavoriteProject(id) {
        return api().put(`/projects/${id}/unfavorite`);
    },

    deleteProject(id) {
        return api().delete(`/projects/${id}`);
    },

    updateOptions(id, params) {
        return api().put(`/projects/${id}/options`, params);
    },

    updateTheme(id, params) {
        return api().put(`/projects/${id}/theme`, params);
    },

    updateTrackingDomain(id, params) {
        return api().put(`/projects/${id}/tracking-domain`, params);
    },

    // Exports

    getExports(id, params) {
        return api().get(`/projects/${id}/exports`, { params: params });
    },

    // Senders

    getSenders(id, params) {
        return api().get(`/projects/${id}/senders`, { params: params });
    },

    // Unsub groups

    getUnsubGroups(id, params) {
        return api().get(`/projects/${id}/unsub-groups`, { params: params });
    },

    // Events

    createEvent(id, params) {
        return api().post(`/projects/${id}/events`, params);
    },

    getEvents(id, params) {
        return api().get(`/projects/${id}/events`, { params: params });
    },

    // Segments

    getSegments(id, params) {
        return api().get(`/projects/${id}/segments`, { params: params });
    },

    createSegment(id, params) {
        return api().post(`/projects/${id}/segments`, params);
    },

    syncSegments(id) {
        return api().post(`/projects/${id}/segments/sync`);
    },

    // Campaigns

    getCampaigns(id, params) {
        return api().get(`/projects/${id}/campaigns`, { params: params });
    },

    createCampaign(id, params) {
        return api().post(`/projects/${id}/campaigns`, params);
    },

    // Customers

    createCustomer(id, params) {
        return api().post(`/projects/${id}/customers`, params);
    },

    createCustomers(id, params) {
        return api().post(`/projects/${id}/customers/bulk`, params);
    },

    createCustomersWithCSV(id, params) {
        return api().post(`/projects/${id}/customers/upload`, params);
    },

    getCustomers(id, params) {
        return api().get(`/projects/${id}/customers`, { params: params });
    },

    searchCustomers(id, params) {
        return api().post(`/projects/${id}/customers/search`, params);
    },

    tagCustomers(id, params) {
        return api().post(`/projects/${id}/customers/bulk/tag`, params);
    },

    untagCustomers(id, params) {
        return api().delete(`/projects/${id}/customers/bulk/tag`, { params: params });
    },

    segmentCustomers(id, params) {
        return api().post(`/projects/${id}/customers/bulk/segment`, params);
    },

    deleteCustomers(id, params) {
        return api().delete(`/projects/${id}/customers/bulk`, { params: params });
    },

    // SMTP

    updateSmtp(id, params) {
        return api().put(`/projects/${id}/smtp`, params);
    },

    deleteSmtp(id) {
        return api().delete(`/projects/${id}/smtp`);
    },

    // Tags

    getTags(id, params) {
        return api().get(`/projects/${id}/tags`, { params: params });
    },

    createTag(id, params) {
        return api().post(`/projects/${id}/tags`, params);
    },

    // Domains

    createDomain(id, params) {
        return api().post(`/projects/${id}/domains`, params);
    },

    deleteDomain(id) {
        return api().delete(`/projects/${id}/domains`);
    },

    // Traits

    getTraits(id, params) {
        return api().get(`/projects/${id}/traits`, { params: params });
    },

    createTrait(id, params) {
        return api().post(`/projects/${id}/traits`, params);
    },

    sortTraits(id, params) {
        return api().put(`/projects/${id}/traits/sort`, params);
    },

    // Integrations

    getIntegrations(id) {
        return api().get(`/projects/${id}/integrations`);
    },

    getIntegration(id, service, params) {
        return api().get(`/projects/${id}/integrations/${service}`, { params: params });
    },

    createIntegration(id, slug, params) {
        return api().post(`/projects/${id}/integrations/${slug}`, params);
    },

    deleteIntegration(id, integration_id) {
        return api().delete(`/projects/${id}/integrations/${integration_id}`);
    },

    // Keys

    getKeys(id) {
        return api().get(`/projects/${id}/keys`);
    },

    createKey(id, params) {
        return api().post(`/projects/${id}/keys`, params);
    },

    // Templates

    getTemplates(id, params) {
        return api().get(`/projects/${id}/templates`, { params: params });
    },

    createTemplate(id, params) {
        return api().post(`/projects/${id}/templates`, params);
    },

    // Blocks

    getBlocks(id, params) {
        return api().get(`/projects/${id}/blocks`, { params: params });
    },

    createBlock(id, params) {
        return api().post(`/projects/${id}/blocks`, params);
    },

    // Forms

    getForms(id, params) {
        return api().get(`/projects/${id}/forms`, { params: params });
    },

    createForm(id, params) {
        return api().post(`/projects/${id}/forms`, params);
    },

}
